import MobileDetect from 'mobile-detect';
import * as paper from 'paper';

import {
    prepareStroke
} from './animate.js';

import {
    constables
} from './base.js';

const breakpoint = constables().breakpoint;

const times = constables().times;
const timem = constables().timem;
const timel = constables().timel;

var WEIGHTS = {};
var weight_buffer = null;
var W = null;
var w32 = null;
var w16 = null;

var ctx = null;
var canvas = null;
var RNN_SIZE = 512;
var cur_run = 0;

// INIT

export function initmanuskripte() {

    routes();

}

function routes() {

    try {
        if (!!manuskripte) {
            build();
        }
    } catch {

    }


}

function build() {

    var md = new MobileDetect(window.navigator.userAgent);
    if (!md.mobile()) {
        window.addEventListener('load', () => {

            manuskripte.paths = [];
            manuskripte.points = [];
            manuskripte.index = 0;
            manuskripte.wort = 0;
            manuskripte.svg = [];
            manuskripte.interval = false;

            let text = manuskripte.text.slice(0);
            manuskripte.text.splice(0, manuskripte.text.length);

            text.forEach(t => {

                let w = t.split(' ');
                manuskripte.text.push(w);

            })

            let canvas = document.createElement('canvas');

            manuskripte.c = new paper.PaperScope();
            manuskripte.c.setup(canvas);

            tensorLoad();

        })
    }

}

function tensorLoad() {

    var oReq = new XMLHttpRequest();
    oReq.open("GET", manuskripte.weights, true);
    oReq.responseType = "arraybuffer";

    var weights_meta = {
        'rnn/~/conv1_d__b': [
            [0, 73],
            [73]
        ],
        'rnn/~/conv1_d__w': [
            [73, 26718],
            [5, 73, 73]
        ],
        'rnn/~/embed__embeddings': [
            [26718, 64094],
            [512, 73]
        ],
        'rnn/~/embed_1__embeddings': [
            [64094, 69423],
            [73, 73]
        ],
        'rnn/~/linear__b': [
            [69423, 69454],
            [31]
        ],
        'rnn/~/linear__w': [
            [69454, 85326],
            [512, 31]
        ],
        'rnn/~/lstm_attention_core/~/gru__b': [
            [85326, 86862],
            [1536]
        ],
        'rnn/~/lstm_attention_core/~/gru__w_h': [
            [86862, 873294],
            [512, 1536]
        ],
        'rnn/~/lstm_attention_core/~/gru__w_i': [
            [873294, 990030],
            [76, 1536]
        ],
        'rnn/~/lstm_attention_core/~/gru_1__b': [
            [990030, 991566],
            [1536]
        ],
        'rnn/~/lstm_attention_core/~/gru_1__w_h': [
            [991566, 1777998],
            [512, 1536]
        ],
        'rnn/~/lstm_attention_core/~/gru_1__w_i': [
            [1777998, 2681166],
            [588, 1536]
        ],
        'rnn/~/lstm_attention_core/~/linear__b': [
            [2681166, 2681169],
            [3]
        ],
        'rnn/~/lstm_attention_core/~/linear__w': [
            [2681169, 2682933],
            [588, 3]
        ]
    };

    oReq.onload = function(oEvent) {
        var arrayBuffer = oReq.response;
        if (arrayBuffer) {

            W = new Float32Array(arrayBuffer);

            for (var k in weights_meta) {
                var info = weights_meta[k];
                var offset = info[0];
                var shape = info[1];
                WEIGHTS[k] = tf.tensor(W.subarray(offset[0], offset[1]), shape);
            }

            tf.engine().startScope();
            write();


        }
    };

    tf.setBackend('wasm');
    tf.ready().then(function() {
        tf.enableProdMode();
        oReq.send(null);
    });

}

function write() {

    generate();

}


var randn = function() {
    var u = Math.random() * 0.999 + 1e-5;
    var v = Math.random() * 0.999 + 1e-5;
    return Math.sqrt(-2.0 * Math.log(u)) * Math.cos(2.0 * Math.PI * v);
}

var rand_truncated_normal = function(low, high) {
    while (true) {
        var r = randn();
        if (r >= low && r <= high)
            break;
        // rejection sampling.
    }
    return r;
}

var softplus = function(x) {
    const m = tf.maximum(x, 0.0);
    return tf.add(m, tf.log(tf.add(tf.exp(tf.neg(m)), tf.exp(tf.sub(x, m)))));
}


var char2idx = {
    '\x00': 0,
    ' ': 1,
    '!': 2,
    '"': 3,
    '#': 4,
    "'": 5,
    '(': 6,
    ')': 7,
    ',': 8,
    '-': 9,
    '.': 10,
    '0': 11,
    '1': 12,
    '2': 13,
    '3': 14,
    '4': 15,
    '5': 16,
    '6': 17,
    '7': 18,
    '8': 19,
    '9': 20,
    ':': 21,
    ';': 22,
    '?': 23,
    'A': 24,
    'B': 25,
    'C': 26,
    'D': 27,
    'E': 28,
    'F': 29,
    'G': 30,
    'H': 31,
    'I': 32,
    'J': 33,
    'K': 34,
    'L': 35,
    'M': 36,
    'N': 37,
    'O': 38,
    'P': 39,
    'R': 40,
    'S': 41,
    'T': 42,
    'U': 43,
    'V': 44,
    'W': 45,
    'Y': 46,
    'a': 47,
    'b': 48,
    'c': 49,
    'd': 50,
    'e': 51,
    'f': 52,
    'g': 53,
    'h': 54,
    'i': 55,
    'j': 56,
    'k': 57,
    'l': 58,
    'm': 59,
    'n': 60,
    'o': 61,
    'p': 62,
    'q': 63,
    'r': 64,
    's': 65,
    't': 66,
    'u': 67,
    'v': 68,
    'w': 69,
    'x': 70,
    'y': 71,
    'z': 72
};

var gru_core = function(input, weights, state, hidden_size) {
    var [w_h, w_i, b] = weights;
    var [w_h_z, w_h_a] = tf.split(w_h, [2 * hidden_size, hidden_size], 1);
    var [b_z, b_a] = tf.split(b, [2 * hidden_size, hidden_size], 0);
    var gates_x = tf.matMul(input, w_i);
    var [zr_x, a_x] = tf.split(gates_x, [2 * hidden_size, hidden_size], 1);
    var zr_h = tf.matMul(state, w_h_z);
    var zr = tf.add(tf.add(zr_x, zr_h), b_z);

    // fix this
    var [z, r] = tf.split(tf.sigmoid(zr), 2, 1);
    var a_h = tf.matMul(tf.mul(r, state), w_h_a);
    var a = tf.tanh(tf.add(tf.add(a_x, a_h), b_a));
    var next_state = tf.add(tf.mul(tf.sub(1., z), state), tf.mul(z, a));
    return [next_state, next_state];
};


var generate = function() {

    manuskripte.points.splice(0, manuskripte.points.length);
    manuskripte.paths.splice(0, manuskripte.paths.length);

    cur_run = cur_run + 1;
    var counter = 2000;
    tf.disposeVariables();

    tf.engine().startScope();
    dojob(cur_run);

    return false;
}

var dojob = function(run_id) {
    var text = manuskripte.text[manuskripte.index][manuskripte.wort];

    var cur_x = 50.;
    var cur_y = 300.;


    var original_text = text;
    text = text;

    text = Array.from(text).map(function(e) {
        return char2idx[e]
    })
    var text_embed = WEIGHTS['rnn/~/embed_1__embeddings'];
    var indices = tf.tensor1d(text, 'int32');
    text = text_embed.gather(indices);

    var filter = WEIGHTS['rnn/~/conv1_d__w'];
    var embed = tf.conv1d(text, filter, 1, 'same');
    var bias = tf.expandDims(WEIGHTS['rnn/~/conv1_d__b'], 0);
    embed = tf.add(embed, bias);

    var writer_embed = WEIGHTS['rnn/~/embed__embeddings'];
    var wid = 15;

    wid = tf.tensor1d([wid], 'int32');
    wid = writer_embed.gather(wid);
    embed = tf.add(wid, embed);

    // initial state
    var gru0_hx = tf.zeros([1, RNN_SIZE]);
    var gru1_hx = tf.zeros([1, RNN_SIZE]);
    // var gru2_hx = tf.zeros([1, RNN_SIZE]);

    var att_location = tf.zeros([1, 1]);
    var att_context = tf.zeros([1, 73]);

    var input = tf.tensor([
        [0., 0., 1.]
    ]);

    var gru0_w_h = WEIGHTS['rnn/~/lstm_attention_core/~/gru__w_h'];
    var gru0_w_i = WEIGHTS['rnn/~/lstm_attention_core/~/gru__w_i'];
    var gru0_bias = WEIGHTS['rnn/~/lstm_attention_core/~/gru__b'];

    var gru1_w_h = WEIGHTS['rnn/~/lstm_attention_core/~/gru_1__w_h'];
    var gru1_w_i = WEIGHTS['rnn/~/lstm_attention_core/~/gru_1__w_i'];
    var gru1_bias = WEIGHTS['rnn/~/lstm_attention_core/~/gru_1__b'];
    var att_w = WEIGHTS['rnn/~/lstm_attention_core/~/linear__w'];
    var att_b = WEIGHTS['rnn/~/lstm_attention_core/~/linear__b'];
    var gmm_w = WEIGHTS['rnn/~/linear__w'];
    var gmm_b = WEIGHTS['rnn/~/linear__b'];

    var ruler = tf.tensor([...Array(text.shape[0]).keys()]);
    var bias = 100 / 100 * 3;

    cur_x = 0.;
    cur_y = 0.;
    var dx = 0.;
    var dy = 0;
    var eos = 1.;
    var counter = 0;


    function loop(my_run_id) {
        if (my_run_id < cur_run) {
            tf.disposeVariables();
            tf.engine().endScope();
            return;
        }

        counter++;
        if (counter < 2000) {
            [att_location, att_context, gru0_hx, gru1_hx, input] = tf.tidy(function() {
                // Attention
                const inp_0 = tf.concat([att_context, input], 1);
                var gru0_hx_ = gru0_hx;
                var out_0;
                [out_0, gru0_hx] = gru_core(inp_0, [gru0_w_h, gru0_w_i, gru0_bias], gru0_hx, RNN_SIZE);
                tf.dispose(gru0_hx_);
                const att_inp = tf.concat([att_context, input, out_0], 1);
                const att_params = tf.add(tf.matMul(att_inp, att_w), att_b);
                var [alpha, beta, kappa] = tf.split(softplus(att_params), 3, 1);
                var att_location_ = att_location;
                att_location = tf.add(att_location, tf.div(kappa, 25.));
                tf.dispose(att_location_)

                const phi = tf.mul(alpha, tf.exp(tf.div(tf.neg(tf.square(tf.sub(att_location, ruler))), beta)));
                var att_context_ = att_context;
                att_context = tf.sum(tf.mul(tf.expandDims(phi, 2), tf.expandDims(embed, 0)), 1)
                tf.dispose(att_context_);

                const inp_1 = tf.concat([input, out_0, att_context], 1);
                tf.dispose(input);
                var gru1_hx_ = gru1_hx;
                var out_1;
                [out_1, gru1_hx] = gru_core(inp_1, [gru1_w_h, gru1_w_i, gru1_bias], gru1_hx, RNN_SIZE);
                tf.dispose(gru1_hx_);

                // GMM
                const gmm_params = tf.add(tf.matMul(out_1, gmm_w), gmm_b);
                var [x, y, logstdx, logstdy, angle, log_weight, eos_logit] = tf.split(gmm_params, [5, 5, 5, 5, 5, 5, 1], 1);
                // log_weight = tf.softmax(log_weight, 1);
                // log_weight = tf.log(log_weight);
                // log_weight = tf.mul(log_weight, 1. + bias);
                // const idx = tf.multinomial(log_weight, 1).dataSync()[0];
                // log_weight = tf.softmax(log_weight, 1);
                // log_weight = tf.log(log_weight);
                // log_weight = tf.mul(log_weight, 1. + bias);
                const idx = tf.argMax(log_weight, 1).dataSync()[0];

                x = x.dataSync()[idx];
                y = y.dataSync()[idx];
                const stdx = tf.exp(tf.sub(logstdx, bias)).dataSync()[idx];
                const stdy = tf.exp(tf.sub(logstdy, bias)).dataSync()[idx];
                angle = angle.dataSync()[idx];
                var e = tf.sigmoid(tf.mul(eos_logit, (1. + 0. * bias))).dataSync()[0];
                const rx = rand_truncated_normal(-5, 5) * stdx;
                const ry = rand_truncated_normal(-5, 5) * stdy;
                x = x + Math.cos(-angle) * rx - Math.sin(-angle) * ry;
                y = y + Math.sin(-angle) * rx + Math.cos(-angle) * ry;
                if (Math.random() < e) {
                    e = 1.;
                } else {
                    e = 0.;
                }
                input = tf.tensor([
                    [x, y, e]
                ]);
                return [att_location, att_context, gru0_hx, gru1_hx, input];
            });

            var [dx, dy, eos_] = input.dataSync();
            dy = -dy * 3;
            dx = dx * 3;
            if (eos == 0.) {
                let p = {
                    x: cur_x + dx,
                    y: cur_y + dy
                }
                manuskripte.points.push(p);
            } else {

                let path = manuskripte.points.slice(0);
                manuskripte.paths.push(path);
                manuskripte.points.splice(0, manuskripte.points.length);

                let p = {
                    x: cur_x + dx,
                    y: cur_y + dy
                }
                manuskripte.points.push(p);


            }
            eos = eos_;
            cur_x = cur_x + dx;
            cur_y = cur_y + dy;

            if (att_location.dataSync()[0] < original_text.length + 2) {
                setTimeout(() => {
                    loop(my_run_id);

                }, 0);
            } else {

                let path = manuskripte.points.slice(0);
                manuskripte.paths.push(path);
                manuskripte.points.splice(0, manuskripte.points);

                buildpaper();
                tf.disposeVariables();
                tf.engine().endScope();

                return;
            }
        } else {
            let path = manuskripte.points.slice(0);
            manuskripte.paths.push(path);
            manuskripte.points.splice(0, manuskripte.points);

            buildpaper();

            tf.disposeVariables();
            tf.engine().endScope();

            return;
        }
    }

    loop(run_id);
}

function buildpaper() {

    let b = manuskripte.c.project.activeLayer.bounds;
    let bt = b.height;
    let bx = 0;

    if (manuskripte.c.project.activeLayer.children.length % 2 !== 0 && manuskripte.c.project.activeLayer.children.length != 0) {
        b = manuskripte.c.project.activeLayer.children[manuskripte.c.project.activeLayer.children.length - 1].bounds;
        bt = b.y + b.height * 1.5;
        if (bt < 0){
            bt = 0;
        }
        bx = b.right + b.height/6;
    }

    let group = new paper.Group();

    manuskripte.paths.forEach(line => {

        let path = new paper.Path();
        path.strokeColor = 'black';
        path.strokeWidth = 3

        line.forEach(p => {

            path.add(new paper.Point(p.x, p.y));

        })

        path.strokeJoin = 'round';
        path.strokeCap = 'round';
        path.smooth();
        path.simplify();

        path.position.y += bt;
        path.position.x += bx;

        group.addChild(path);

    });

    manuskripte.wort++;
    if (manuskripte.wort < manuskripte.text[manuskripte.index].length) {

        setTimeout(() => {
            generate();
        }, 0);

    } else {

        let vw = window.innerWidth * 0.7;
        let b = manuskripte.c.project.activeLayer.bounds.width;

        let ratio = vw / b;
        manuskripte.c.project.activeLayer.scale(ratio);

        manuskripte.lines = manuskripte.c.project.exportSVG({
            asString: true,
            bounds: 'content'
        });
        manuskripte.c.project.clear();
        drawpaper();

    }

}

function drawpaper() {

    let r = document.getElementById('manuskripte');

    let group = document.createElement('section');
    group.classList.add('manuskript-group');

    group.style.paddingLeft = Math.random() * (5 + 1) + "%";
    group.style.paddingRight = Math.random() * (5 + 1) + "%";
    group.style.paddingTop = Math.random() * (5 + 1) + "%";
    // group.style.paddingBottom = Math.floor(Math.random() * (10 + 1)) + "%";

    let paths = group.querySelectorAll('path');
    paths.forEach(path => {

        path.setAttribute('vector-effect', 'non-scaling-stroke');

    })

    r.appendChild(group);

    group.innerHTML += manuskripte.lines;

    let parent = group.lastElementChild;
    let width = parent.getAttribute('width');
    parent.dataset.width = width;
    parent.classList.add('slow');

    let ball = {
        group: group,
        svg: parent
    }
    manuskripte.svg.push(ball);

    if (manuskripte.interval == false) {

        interaction();

    }

    manuskripte.wort = 0;
    manuskripte.lines = '';
    manuskripte.index++;
    if (manuskripte.index < manuskripte.text.length) {
        setTimeout(() => {
            generate();
        }, 2000);
    }

}

function interaction() {

    let r = document.getElementById('manuskripte');
    let interval = 3000;

    document.addEventListener('pointermove', () => {
        clearInterval(manuskripte.interval);
        manuskripte.interval = setInterval(() => {

            idle();
            clearInterval(manuskripte.interval);

        }, interval)

        moved(r);

    })

    document.addEventListener('scroll', () => {
        clearInterval(manuskripte.interval);
        manuskripte.interval = setInterval(() => {

            idle();
            clearInterval(manuskripte.interval);

        }, interval)

        moved(r);

    })

}


function idle() {

    if (manuskripte.svg.length) {

        prepareStroke(manuskripte.svg[0].svg);
        manuskripte.svg[0].group.classList.add('aktiv');
        manuskripte.svg.shift();

    }

}

function moved(r) {

    let groups = r.querySelectorAll('section.manuskript-group.aktiv');

    groups.forEach(group => {

        let parent = group.lastElementChild;

        group.classList.remove('aktiv');
        parent.classList.add('remove');
        setTimeout(() => {

            parent.remove();
            group.remove();

        }, 1000)

    })

}